<script lang="ts" setup>
import { useLessonRoomStore } from '@stores/lesson-room'

import { useClassroomChat } from '@hooks/classroom/chat.hook'

import qaConfig from '@config/qa.json'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonChat',
})

const lessonRoomStore = useLessonRoomStore()
const { toggleChat, isReady } = useClassroomChat()
</script>

<template>
  <LessonRoomControlButton
    :icon="{ name: 'message' }"
    label="Chat"
    :enabled="lessonRoomStore.isChatOpen"
    :has-alert="lessonRoomStore.hasChatUnread"
    :disabled="!isReady"
    :data-qa="qaConfig.attributes.buttonChat"
    @click="toggleChat"
  />
</template>
